import styled from 'styled-components';

export const AreaEditablePopupContainer = styled.div`
  width: 350px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  text-align: center;

  & > div {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0px;

    & > p {
      margin-bottom: 0.3rem;
      width: 70px;
      text-align: left;
    }

    & > input, & > select {
      width: 180px;
    }

    & > button {
      font-size: 12px;
      background-color: #3d4a5c;
      border-width: 0px;
      padding: .375rem 1.5rem;
      margin: 0px 10px;
      color: #fff;
    }
  }
`;